<template>
  <div class="tw-relative tw-w-full tw-h-full">
    <ImageControls
      :image="image"
      :image-type="imageType"
      :location="location"
      @show-image="$emit('show-image')"
      @show-video="$emit('show-video')"
    />
    <ImageWithLabel
      :has-rounded-corners="hasRoundedCorners"
      :image-url="image.image_url"
      :large="large"
      :subtitle="subtitle"
      :title="title"
      @click="$emit('show-image')"
    />
  </div>
</template>

<script>
export default {
  name: 'ImageView',

  props: {
    hasRoundedCorners: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Object,
      required: true,
    },
    imageType: {
      type: String,
      required: true,
      validator(value) {
        return ['cam', 'trail_map'].includes(value);
      },
    },
    isFavorites: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
  },

  emits: ['show-image', 'show-video'],

  computed: {
    subtitle() {
      return this.isFavorites ? this.image.name : '';
    },

    title() {
      return this.isFavorites ? this.location.name : this.image.name;
    },
  },
};
</script>
